<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <b-input
          v-model="searchText"
          debounce="500"
          trim
          size="sm"
          placeholder="search..."
        ></b-input>
        <small class="text-muted"
          >If not found, it means that there is no manual settings for the
          measure group.</small
        >
        <small class="text-muted">It will be using the default values.</small>
      </b-col>
      <b-col cols="3">
        <b-button
          size="sm"
          variant="outline-primary"
          class="d-inline-block ml-3"
          @click="addMeasureGroup"
        >
          Add
        </b-button>
      </b-col>
    </b-row>
    <b-list-group>
      <b-list-group-item
        v-for="measureGroup in filteredMeasureGroups"
        :key="measureGroup.id"
        @click="loadMeasureGroup(measureGroup)"
        class="dashboard-list-item"
      >
        <b-row>
          <b-col>
            <span>
              {{ measureGroup.measureGroupCaption }}
            </span>
          </b-col>
          <b-col cols="3" sm="2" lg="1">
            <b-badge variant="secondary" v-if="measureGroup.isHidden"
              >Hidden
            </b-badge>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ measureGroup.measureGroupId }}</small>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

    <b-modal
      v-model="formModal"
      centered
      hide-header
      size="lg"
      button-size="sm"
      ok-title="Submit"
      @ok="submit"
    >
      <b-row class="mb-3">
        <b-col>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="deleteMeasureGroup"
            class="float-right"
            >Delete
          </b-button>
        </b-col>
      </b-row>
      <b-form ref="main-form">
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Measure Group Unique Name</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.measureGroupId"
              placeholder="Fact Bet"
              size="sm"
              autofocus
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Measure Group Caption</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.measureGroupCaption"
              placeholder="Bet"
              size="sm"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Hidden?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.isHidden"
              :value="true"
              :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import notification from '@/mixins/notification';
import adminServices from '../../services/adminServices';

export default {
  name: 'MeasureGroupConfigs',
  props: ['cubeId'],
  mixins: [notification],
  mounted() {
    this.getList();
  },
  computed: {
    filteredMeasureGroups() {
      const searchText = this.searchText.toLowerCase();
      let filteredMeasureGroups = _.filter(this.measureGroups, {
        cubeConfigId: this.cubeId,
      });
      filteredMeasureGroups = _.filter(filteredMeasureGroups, measureGroup => {
        return measureGroup.measureGroupId.toLowerCase().includes(searchText);
      });
      return filteredMeasureGroups;
    },
  },
  data() {
    return {
      measureGroups: [],
      formItems: defaultFormItems(),

      formats: [
        { value: 'INTEGER', text: 'Integer' },
        { value: 'MONEY', text: 'Money' },
        { value: 'PERCENTAGE', text: 'Percentage' },
        { value: 'DECIMAL', text: 'Decimal' },
      ],
      searchText: '',
      formModal: false,
      isEdit: false,
    };
  },
  methods: {
    getList() {
      adminServices.getMeasureGroupConfigs().then(resp => {
        this.measureGroups = resp.data;
      });
    },
    loadMeasureGroup(measureGroup) {
      this.isEdit = true;
      this.formItems = {
        ..._.cloneDeep(measureGroup),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    addMeasureGroup() {
      this.isEdit = false;
      this.formItems = {
        ...defaultFormItems(),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    deleteMeasureGroup() {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete setting?', { centered: true })
        .then(value => {
          if (value) {
            this.formModal = false;
            adminServices
              .deleteMeasureGroupConfigs(this.formItems.id)
              .then(() => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been deleted successfully.'
                );
                this.measureGroups = _.filter(
                  this.measureGroups,
                  measureGroup => measureGroup.id !== this.formItems.id
                );
              });
          }
        });
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const formItems = _.cloneDeep(this.formItems);
      if (this.isEdit) {
        this.$bvModal
          .msgBoxConfirm('Proceed to edit setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              adminServices.putMeasureGroupConfigs(formItems).then(() => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been updated successfully.'
                );
                let measureGroups = _.filter(
                  this.measureGroups,
                  measureGroup => measureGroup.id !== formItems.id
                );
                measureGroups.push(formItems);
                this.measureGroups = measureGroups;
              });
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm('Proceed to add setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              adminServices.postMeasureGroupConfigs(formItems).then(resp => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been added successfully.'
                );
                this.measureGroups.push(resp.data);
              });
            }
          });
      }
    },
  },
};

const defaultFormItems = () => {
  return {
    measureId: '',
    measureCaption: '',
    measureFormat: 'MONEY',
    isHidden: false,
    cubeConfigId: 1,
  };
};
</script>

<style scoped>
.dashboard-list-item {
  cursor: pointer;
}

.dashboard-list-item:hover {
  background-color: #ebebeb;
}
</style>